import { render, staticRenderFns } from "./merge-client-profile-warning.vue?vue&type=template&id=0f1ef8e8"
import script from "./merge-client-profile-warning.vue?vue&type=script&lang=js"
export * from "./merge-client-profile-warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports